import { render, staticRenderFns } from "./RequesterTBPage.vue?vue&type=template&id=6669b449&"
import script from "./RequesterTBPage.vue?vue&type=script&lang=js&"
export * from "./RequesterTBPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6669b449')) {
      api.createRecord('6669b449', component.options)
    } else {
      api.reload('6669b449', component.options)
    }
    module.hot.accept("./RequesterTBPage.vue?vue&type=template&id=6669b449&", function () {
      api.rerender('6669b449', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/toolbox/RequesterTBPage.vue"
export default component.exports